import React from "react";
import { CopyClipboardIcon } from "./SvgIcon";

const FormField = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  onCopy,
  type = "text"
}) => {
  
  const handleChange = (e) => {
    let val = e.target.value;

    if (type === "tel") {
      val = val.replace(/[^0-9]/g, "");
    }

    onChange({
      target: { name, value: val }
    });
  };

  return (
    <div className="flex items-center gap-4 pl-3 py-3 pb-[22px] border-b border-[#E4E4E7]">
      
      <label className="text-sm font-medium text-[#17171C] min-w-[220px]">
        {label}
      </label>

      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        className="h-12 w-[674px] !rounded-xl border !border-[#E4E4E7] px-4 text-sm text-[#17171C] focus:!border-[#17171C] focus:!shadow-none focus:!ring-0 outline-none"
      />

      <button
        type="button"
        onClick={() => onCopy(placeholder)}
        className="!rounded-xl p-2 text-gray-400 transition hover:bg-gray-50 hover:text-gray-700 flex-shrink-0"
      >
        <CopyClipboardIcon />
      </button>

      <div className="text-sm text-[#6F6F7B] bg-[#F4F4F5] !rounded-xl px-2 py-1 text-center min-w-[180px] flex-shrink-0">
        {placeholder}
      </div>
    </div>
  );
};

export default FormField;